import React, { useEffect, useRef } from "react";

const ADSENSE_CLIENT = "ca-pub-1751015629664278";

/**
 * AdSlot — renders a Google AdSense ad unit.
 * Props:
 *  - slot:   AdSense ad slot ID (string). Required for production fill.
 *  - format: 'auto' | 'fluid' | 'rectangle' | 'horizontal' | etc.
 *  - layout: optional 'in-article' | 'in-feed' for native formats
 *  - layoutKey: optional layout key for in-feed
 *  - className: wrapper class
 *  - style: inline style for the <ins>
 *  - testId: data-testid for the wrapper
 *  - responsive: true|false
 *
 * If the slot ID is not provided we show a non-clickable placeholder so the
 * publisher can confirm placement before adding real slot IDs in AdSense UI.
 */
export default function AdSlot({
  slot,
  format = "auto",
  layout,
  layoutKey,
  className = "",
  style,
  testId = "ad-slot",
  responsive = true,
}) {
  const insRef = useRef(null);
  const pushedRef = useRef(false);

  useEffect(() => {
    if (!slot) return;
    if (pushedRef.current) return;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
      pushedRef.current = true;
    } catch (e) {
      // adblock or script not loaded yet — silent
    }
  }, [slot]);

  if (!slot) {
    return (
      <div
        data-testid={`${testId}-placeholder`}
        className={`border border-dashed border-white/15 bg-white/[0.02] flex items-center justify-center text-[10px] uppercase tracking-[0.25em] text-white/30 ${className}`}
        style={{ minHeight: 90, ...style }}
      >
        Advertisement
      </div>
    );
  }

  return (
    <div data-testid={testId} className={className}>
      <ins
        ref={insRef}
        className="adsbygoogle"
        style={{ display: "block", ...style }}
        data-ad-client={ADSENSE_CLIENT}
        data-ad-slot={slot}
        data-ad-format={format}
        data-ad-layout={layout}
        data-ad-layout-key={layoutKey}
        data-full-width-responsive={responsive ? "true" : "false"}
      />
    </div>
  );
}
